import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row
} from "reactstrap";
import threeDotsIcon from "../../../assets/images/three-dots.png";
import InvitesTeammatesModal from "./InvitesTeammatesModal";
import addUsersToSubTeam from "../apis/addUsersToSubTeam";
import removeUsersFromSubTeam from "../apis/removeUsersFromSubTeam";
import ChevronDownOutlined from "../chevron/ChevronDownOutlined";
import ChevronUpOutlined from "../chevron/ChevronUpOutlined";
import RemoveUserFromTeamModal from "./RemoveUserFromTeamModal";
import EditUserInTeamModal from "./EditUserInTeamModal";
import TeamCapacityModal from "../../landingLibrary/teamCapacityModal";

const TeamTable = ({ currentUser, setIsLoading, DummyAvatarSvg }) => {
  const [team_filter_dropdown, set_team_filter_dropdown] = useState(false);
  // const [invite_modal, set_invite_modal] = useState(false);
  const [remove_user_modal, set_remove_user_modal] = useState(null);

  const [edit_user_modal, set_edit_user_modal] = useState(null);
  // const [magic_link, set_magic_link] = useState(null);
  const [users, set_users] = useState([]);
  const [sub_team_filter, set_sub_team_filter] = useState("All Teammates");
  const [host_remove_modal, set_host_remove_modal] = useState({
    isOpen: false,
    teammate: ""
  });
  const [teamTableThreeDotDrpdwn, setTeamTableThreeDotDrpdwn] = useState(false);
  const manageTooltipRef = useRef(null);
  useEffect(() => {
    if (currentUser?.team?.users?.length > 0) {
      const temp = currentUser.team.users.map((user) => {
        return {
          ...user,
          team_dropdown: false,
          tooltip: false
        };
      });
      set_users(temp);
    }
  }, [JSON.stringify(currentUser.team)]);

  useEffect(() => {
    let temp = [];
    if (sub_team_filter == "All Teammates") {
      temp = currentUser?.team?.users?.map((user) => {
        return {
          ...user,
          team_dropdown: false,
          tooltip: false
        };
      });
    } else if (sub_team_filter == "Default (Unassigned)") {
      temp = currentUser?.team?.users.filter((user) => !user.sub_team);
      temp = temp?.map((item) => {
        return { ...item, team_dropdown: false, tooltip: false };
      });
    } else {
      temp = currentUser?.team?.users.filter(
        (user) => user.sub_team == sub_team_filter
      );
      temp = temp?.map((item) => {
        return { ...item, team_dropdown: false, tooltip: false };
      });
    }
    set_users(temp);
  }, [sub_team_filter]);
  useEffect(() => {
    const handleClickOutsideManage = (event) => {
      if (
        teamTableThreeDotDrpdwn &&
        manageTooltipRef.current &&
        !manageTooltipRef.current.contains(event.target)
      ) {
        setTeamTableThreeDotDrpdwn(false);
      }
    };

    document.addEventListener("click", handleClickOutsideManage);

    return () => {
      document.removeEventListener("click", handleClickOutsideManage);
    };
  }, [teamTableThreeDotDrpdwn]);

  // const toggle_intive_modal = () => set_invite_modal(!invite_modal);

  // const getMagicLink = () => {
  //   setIsLoading(true);
  //   let url = process.env.REACT_APP_GET_MAGIC_LINK;
  //   url = `${url}?team_code=${currentUser.team.id}&user_name=${currentUser?.username}`;
  //   axios({
  //     method: "GET",
  //     url,
  //   })
  //     .then((data) => {
  //       setIsLoading(false);
  //       set_magic_link(data.data.url);
  //       toggle_intive_modal();
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //       console.log(err, "errerr");
  //     });
  // };

  const handle_team_dropdown_toggle = (item) => {
    const temp_users = [...users];
    const array = temp_users?.map((value) =>
      value.Username === item.Username
        ? { ...value, team_dropdown: !value.team_dropdown, tooltip: false }
        : { ...value, team_dropdown: false, tooltip: false }
    );

    set_users(array);
  };

  const handle_team_tooltip_toggle = (item) => {
    const temp_users = [...users];
    const array = temp_users?.map((value) =>
      value.Username === item.Username
        ? { ...value, tooltip: true }
        : { ...value, tooltip: false }
    );
    set_users(array);
    setTeamTableThreeDotDrpdwn(true);
  };

  const handleRemoveUser = (user) => {
    if (user.user_id === currentUser.team.manager) {
      if (currentUser.userId === currentUser.team.manager) {
        set_host_remove_modal({ isOpen: true, teammate: "host" });
      } else {
        set_host_remove_modal({ isOpen: true, teammate: "user" });
      }
    } else {
      set_host_remove_modal({ isOpen: false, teammate: "" });
      set_remove_user_modal(user);
    }
  };

  return (
    <>
      {/* {!!invite_modal && (
        <InvitesTeammatesModal
          invite_modal={invite_modal}
          toggle_intive_modal={toggle_intive_modal}
          magic_link={magic_link}
        />
      )} */}
      {host_remove_modal.isOpen && (
        <TeamCapacityModal
          isOpen={host_remove_modal.isOpen}
          host_remove_modal={host_remove_modal}
          onClose={() => set_host_remove_modal({ isOpen: false, teammate: "" })}
        />
      )}
      {!!remove_user_modal && (
        <RemoveUserFromTeamModal
          remove_user_modal={remove_user_modal}
          currentUser={currentUser}
          set_remove_user_modal={set_remove_user_modal}
          DummyAvatarSvg={DummyAvatarSvg}
        />
      )}
      {!!edit_user_modal && (
        <EditUserInTeamModal
          currentUser={currentUser}
          edit_user_modal={edit_user_modal}
          set_edit_user_modal={set_edit_user_modal}
          DummyAvatarSvg={DummyAvatarSvg}
        />
      )}
      <section className="my-team-new-table">
        <Container>
          <Row>
            <Col md={12}>
              <div className="header">
                <div className="all-teammates">
                  {/* <div className="button">
                    <Dropdown
                      isOpen={team_filter_dropdown}
                      toggle={() => {
                        set_team_filter_dropdown(!team_filter_dropdown);
                      }}
                      value={sub_team_filter}
                    >
                      <DropdownToggle className="toggle-item text-white">
                        <span>{sub_team_filter}</span>
                        {team_filter_dropdown ? <ChevronDown /> : <ChevronUp />}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={() => set_sub_team_filter("All Teammates")}
                        >
                          All Teammates
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            set_sub_team_filter("Default (Unassigned)")
                          }
                        >
                          Default (Unassigned)
                        </DropdownItem>
                        {currentUser?.team?.sub_teams?.map((s_team) => (
                          <DropdownItem
                            onClick={() => set_sub_team_filter(s_team.sub_name)}
                          >
                            {s_team.sub_name}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </div> */}
                  {/* <Button
                    color="primary"
                    className="new-team-btn"
                    onClick={getMagicLink}
                  >
                    Invite Teammates
                  </Button> */}
                </div>
                {/* <div className="table-header">
                  <div className="teammate">Teammate</div>
                  <div className="email">Email</div>
                  <div className="team">Team</div>
                </div> */}
              </div>
              <div className="teamone-data-wrapper">
                <div className="team-data">
                  <div className="header-col team-table">
                    <h4>Teammate</h4>
                  </div>
                  <div className="header-col team-table">
                    <h4>Category</h4>
                  </div>
                  <div className="header-col team-table">
                    <h4>Teams</h4>
                  </div>
                  {/* <div className="header-col-dots team-table">
                    <h4></h4>
                  </div> */}
                </div>
                {users?.map((user) => (
                  <>
                    <div className="team-data">
                      <div className="column teammate-col">
                        {user.picture ? (
                          <img src={user.picture} alt="" />
                        ) : (
                          <DummyAvatarSvg className="avatar" />
                        )}
                        <p className="mb-0">{user?.name}</p>
                      </div>
                      <div className="column email-col">
                        <p className="txt mb-0">{user?.email}</p>
                      </div>
                      <div className="column team-col">
                        <div className="team-col-flex">
                          <Dropdown
                            isOpen={user.team_dropdown}
                            toggle={() => handle_team_dropdown_toggle(user)}
                            value={user.sub_team}
                          >
                            <DropdownToggle className="toggle-item2">
                              {user.sub_team || "Default (Unassigned)"}
                              {user.team_dropdown ? (
                                <ChevronUpOutlined color="#606060" />
                              ) : (
                                <ChevronDownOutlined color="#606060" />
                              )}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem
                                onClick={() => {
                                  if (user.sub_team) {
                                    removeUsersFromSubTeam({
                                      team_code: currentUser.team.id,
                                      sub_name: user.sub_team,
                                      user_ids: [user.Username]
                                    });
                                  }
                                }}
                              >
                                Default (Unassigned)
                              </DropdownItem>
                              {currentUser?.team?.sub_teams?.map((s_team) => (
                                <DropdownItem
                                  onClick={() =>
                                    addUsersToSubTeam({
                                      team_code: currentUser.team.id,
                                      sub_name: s_team.sub_name,
                                      user_ids: [user.Username]
                                    })
                                  }
                                >
                                  {s_team.sub_name}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </div>
                      <div
                        className="text-center w-100 three-dots"
                        onClick={() => {
                          handle_team_tooltip_toggle(user);
                        }}
                      >
                        <img src={threeDotsIcon} alt="" />
                        {user.tooltip && teamTableThreeDotDrpdwn && (
                          <div
                            className="tooltip-content"
                            ref={manageTooltipRef}
                          >
                            <ul>
                              <li onClick={() => set_edit_user_modal(user)}>
                                Edit
                              </li>
                              <li onClick={() => handleRemoveUser(user)}>
                                Remove
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TeamTable;
